/* eslint-disable no-param-reassign */
import lsTrackService from '@/services/ls-track/ls-track.service';
import _ from 'lodash';

const lsTrackDirective = {
    bind(el, binding) {
        const { target, state } = binding.value;
        const trackEvent = {
            target,
            state,
        };
        const { attachValue } = binding.value;
        if (binding.modifiers.blur) {
            el.onblur = function (e) {
                trackEvent.type = 'blur';
                if (attachValue) {
                    trackEvent.data = { value: _.get(e, 'target.value') };
                }
                lsTrackService.track(trackEvent);
            };
        }
        if (binding.modifiers.change) {
            el.onchange = function (e) {
                trackEvent.type = 'change';
                if (attachValue) {
                    trackEvent.data = { value: _.get(e, 'target.value') };
                }
                lsTrackService.track(trackEvent);
            };
        }
        if (binding.modifiers.click) {
            el.onclick = function (e) {
                trackEvent.type = 'click';
                if (attachValue) {
                    trackEvent.data = { value: _.get(e, 'target.value') };
                }
                lsTrackService.track(trackEvent);
            };
        }
        if (binding.modifiers.focus) {
            el.onfocus = function (e) {
                trackEvent.type = 'focus';
                if (attachValue) {
                    trackEvent.data = { value: _.get(e, 'target.value') };
                }
                lsTrackService.track(trackEvent);
            };
        }
    },
};

export default lsTrackDirective;
